const state = {
  // Статистика
  stats: {
    users: 0,
    foundations: 0,
    actions: 0,
    emails: 0,
    totalFunds: 0,
    totalFunds: {
      countOfPeople: 0,
      summ: 0,
    },
    starts: 0,
    startsOrganizers: 0,
  },

  // Флаг загружаются ли в текущий момент статистика
  isStatsLoading: false,
};

export default state;
